import { render, staticRenderFns } from "./sk-file-wap.vue?vue&type=template&id=31cc5396&scoped=true&"
import script from "./sk-file-wap.vue?vue&type=script&lang=js&"
export * from "./sk-file-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-file-wap.vue?vue&type=style&index=0&id=31cc5396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc5396",
  null
  
)

export default component.exports